import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import localization from 'moment/locale/de'

import {
    TabsContentHeader,
    TabsContentHeadline,
    TabsContainer
} from '../StyledComponents/Plants/PlantTabs'
import {
    DeviceDetailsImage,
    DeviceDetailsName,
    DeviceDetailsLastUpdate,
    DeviceDetailsOverview,
    DeviceDetailsOverviewIcon,
    DeviceDetailsOverviewText,
    DeviceDetailsLastUpdateHeading,
    DeviceDetailsIrrigationDuration
} from '../StyledComponents/Devices/DeviceDetails'

import { isDefaultValveImage } from '../utilities/helpers'

import { FillerDiv } from '../StyledComponents/Fillers'

const batteryGreen = require('../../assets/images/DevicesList/batteryGreen.svg')
const batteryOrange = require('../../assets/images/DevicesList/batteryOrange.svg')
const batteryRed = require('../../assets/images/DevicesList/batteryRed.svg')

const valveImage = 'https://storage.googleapis.com/staging.flowerai-168618.appspot.com/assets/images/valve.png'
const faucetIcon = require('../../assets/images/DevicesList/faucet.png')

class ValveDetails extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { device } = this.props
        const { soc } = device

        let batteryIcon = null
        let batteryColor = 'black'
        if (soc < 20) {
            batteryIcon = batteryRed
            batteryColor = 'danger'
        } else if (soc < 50) {
            batteryIcon = batteryOrange
            batteryColor = 'warning'
        } else {
            batteryIcon = batteryGreen
            batteryColor = 'success'
        }

        const image = isEmpty(device.image) ? valveImage : device.image

        return (
            <FillerDiv>
                <DeviceDetailsImage
                    contain={isDefaultValveImage(device.image)}
                    src={image}
                    alt={device.name}
                />
                <DeviceDetailsName>{device.name}</DeviceDetailsName>
                <DeviceDetailsLastUpdateHeading>
                    Nächste Bewässerung
                </DeviceDetailsLastUpdateHeading>
                <DeviceDetailsLastUpdate>
                    {`${moment(device.next_irrigation).locale('de', localization).calendar()}`}
                </DeviceDetailsLastUpdate>
                <DeviceDetailsIrrigationDuration>
                    für {device.next_irrigation_duration} Minuten
                </DeviceDetailsIrrigationDuration>
                <TabsContainer>
                    <TabsContentHeader>
                        <TabsContentHeadline margin="0 0 15px 0">Letzte Bewässerung</TabsContentHeadline>
                        <FillerDiv className="container">
                            <DeviceDetailsOverview className="row">
                                <FillerDiv className="col-6">
                                    <DeviceDetailsOverviewIcon src={faucetIcon} alt="Bewaesserung" />
                                    <DeviceDetailsOverviewText>
                                        {moment(device.last_irrigation).locale('de', localization).calendar()}
                                    </DeviceDetailsOverviewText>
                                </FillerDiv>
                                <FillerDiv className="col-6">
                                    <DeviceDetailsOverviewIcon src={batteryIcon} alt="Akkustand" />
                                    <DeviceDetailsOverviewText color={batteryColor}>
                                        {device.soc}%
                                    </DeviceDetailsOverviewText>
                                </FillerDiv>
                            </DeviceDetailsOverview>
                        </FillerDiv>
                    </TabsContentHeader>
                </TabsContainer>
            </FillerDiv>
        )
    }
}

export default ValveDetails



// WEBPACK FOOTER //
// ./src/components/Devices/ValveDetails.js